<template>
  <div class="report-dialog-page" ref="reportDialogPage" v-if="showReport">
    <div class="content" ref="mainReport">
      <div class="action-panel">
        <div class="item-action" @click="doReport" v-if="type<3&&type>0">Report</div>
        <div class="item-action" @click="doClick" v-if="type==3">Delete</div>
      </div>
      <div class="split"></div>
      <div class="cancel-action" @click="hideDialog">Cancel</div>
    </div>
  </div>
</template>

<script>
  import {isnull, Toast} from "../../../utils/tools";
  import momApi from '../../../api/moment-api'
  import TipsUtils from "../../../utils/TipsUtils";
  import BlackUtils from "../../../utils/BlackUtils";

  export default {
    name: "reportdialog",
    props: {
      id: {
        default: 0
      },
      type: {
        default: 0 //1-举报动态 2-举报评论 3-删除
      },
      sucCallback: {
        type: Function,
        default: null
      },
      showReport: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      bodyCloseReportDialog(e) {
        let self = this;
        if (this.$refs.mainReport && !this.$refs.mainReport.contains(e.target)) {
          self.hideDialog();
        }
      },
      hideDialog() {
        this.$emit("hideMomReport");
      },
      doClick(){
        momApi.doDeleteComment(this.id,function (data, page) {
          page.notifyRes(0)
        }, function (code, msg, page) {
          page.notifyRes(code, msg)
        },this)
      },
      doReport() {
        // this.showReportContent()
        if (this.type==1){
          momApi.doReportMoment(this.id,function (data, page) {
            page.notifyRes(0)
          }, function (code, msg, page) {
            page.notifyRes(code, msg)
          },this)
        }else {
          momApi.doReportComment(this.id,function (data, page) {
            page.notifyRes(0)
          }, function (code, msg, page) {
            page.notifyRes(code, msg)
          },this)
        }
        this.hideDialog()

      },
      notifyRes(code, msg = '') {
        console.log(this.sucCallback)
        if (code == 0) {
          Toast.info(this.type!=3?'Reported successfully':'Deleted successfully', this)
          this.sucCallback && this.sucCallback()
        } else {
          Toast.error(TipsUtils.getErrorTips(code), this)
          // Toast.info(this.type!=3?'Reported failed':'Deleted failed', this)
        }
        this.hideDialog()
      },

    },
    watch: {
      showReport(n, o) {
        if (n) {
          let target = this
          setTimeout(function () {
            target.$refs.reportDialogPage.addEventListener("click", target.bodyCloseReportDialog);
          }, 100)

        } else {
          this.$refs.reportDialogPage.removeEventListener("click", this.bodyCloseReportDialog);
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import "~styles/index.less";
  @import "~styles/variable.less";

  .report-dialog-page {
    width: 100% !important;
    height: 100% !important;
    background: rgba(0, 0, 0, .5);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 7;
    position: fixed;
  }

  .content {
    background: #FFFFFF;
    position: fixed;
    .left(0);
    .right(0);
    .btm(0);
    .b-radius(24,24,0,0);
    text-align: center;
    font-family: Gilroy-Medium;

    .item-action {
      width: 100%;
      //.lh(105);
      .h(71);
      .lh(45);
      .pt(34);
      .fs(32);
      font-weight: 600;
      color: #EF4868;
      text-align: center;
      margin: auto;
    }

    .item-action:not(.item-action:last-child)::after {
      width: 100%;
      content: '';
      display: inline-block;
      .h(1);
      background: #ebebeb;
    }

    .cancel-action {
      .h(88);
      .ml(30);
      .mr(30);
      .mb(30);
      .b-radius(49);
      .fs(32);
      text-align: center;
      font-weight: 600;
      color: #999999;
      .lh(88);
    }
    .split{
      background: #f8f8f8;
      .ml(30);
      .mr(30);
      .h(2);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/widget/moment/momentreportdialog.vue